import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/vrart_5g.svg'
import _imports_1 from '@/assets/img/vrart_box.png'
import _imports_2 from '@/assets/img/vrart_balloon1.svg'
import _imports_3 from '@/assets/img/vrart_balloon2.svg'
import _imports_4 from '@/assets/img/vrart_balloon3.svg'
import _imports_5 from '@/assets/img/vrart_balloon1_sp.svg'
import _imports_6 from '@/assets/img/vrart_balloon2_sp.svg'
import _imports_7 from '@/assets/img/vrart_balloon3_sp.svg'


const _withScopeId = n => (_pushScopeId("data-v-4b76157c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "box-top" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "box-5g",
      src: _imports_0,
      alt: ""
    }),
    /*#__PURE__*/_createElementVNode("p", { class: "text3 pc-none" }, [
      /*#__PURE__*/_createTextVNode(" 広島・長崎の学生を"),
      /*#__PURE__*/_createElementVNode("b", null, "NTTドコモの5Gソリューションである「Virtual Design Atelier」"),
      /*#__PURE__*/_createTextVNode("でつなぎ、遠隔でVRデジタルアート制作を実施しました。広島・長崎の学生が同じバーチャル空間に入り、班ごとに考えた平和・未来・世界へ向けた祈りを、最新技術・VRを使ったアート作品に変えて共同で制作し、"),
      /*#__PURE__*/_createElementVNode("b", null, "新たな継承の形"),
      /*#__PURE__*/_createTextVNode("として発表しました。 ")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "box-left" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_1,
        alt: ""
      }),
      /*#__PURE__*/_createElementVNode("img", {
        class: "balloon balloon-1 sp-none",
        src: _imports_2,
        alt: "平和・未来・世界へ向けた祈りをアート作品に"
      }),
      /*#__PURE__*/_createElementVNode("img", {
        class: "balloon balloon-2 sp-none",
        src: _imports_3,
        alt: "バーチャル空間での共同制作"
      }),
      /*#__PURE__*/_createElementVNode("img", {
        class: "balloon balloon-3 sp-none",
        src: _imports_4,
        alt: "せきぐちあいみ氏によるVRアートパフォーマンス"
      }),
      /*#__PURE__*/_createElementVNode("img", {
        class: "balloon balloon-1 pc-none",
        src: _imports_5,
        alt: "平和・未来・世界へ向けた祈りをアート作品に"
      }),
      /*#__PURE__*/_createElementVNode("img", {
        class: "balloon balloon-2 pc-none",
        src: _imports_6,
        alt: "バーチャル空間での共同制作"
      }),
      /*#__PURE__*/_createElementVNode("img", {
        class: "balloon balloon-3 pc-none",
        src: _imports_7,
        alt: "せきぐちあいみ氏によるVRアートパフォーマンス"
      })
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "box-right" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "box-right_wrap" }, [
        /*#__PURE__*/_createElementVNode("p", { class: "text1" }, [
          /*#__PURE__*/_createTextVNode("第 "),
          /*#__PURE__*/_createElementVNode("span", null, "2"),
          /*#__PURE__*/_createTextVNode(" 部")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "line" }),
        /*#__PURE__*/_createElementVNode("h2", null, "VR ART"),
        /*#__PURE__*/_createElementVNode("p", { class: "text2" }, "VRアート共同制作"),
        /*#__PURE__*/_createElementVNode("p", { class: "text3 sp-none" }, [
          /*#__PURE__*/_createTextVNode(" 広島・長崎の学生を"),
          /*#__PURE__*/_createElementVNode("b", null, "NTTドコモの5Gソリューションである「Virtual Design Atelier」"),
          /*#__PURE__*/_createTextVNode("でつなぎ、遠隔でVRデジタルアート制作を実施しました。広島・長崎の学生が同じバーチャル空間に入り、班ごとに考えた平和・未来・世界へ向けた祈りを、最新技術・VRを使ったアート作品に変えて共同で制作し、"),
          /*#__PURE__*/_createElementVNode("b", null, "新たな継承の形"),
          /*#__PURE__*/_createTextVNode("として発表しました。 ")
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    id: "vrart",
    class: "content"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "content-title" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "content-title_en" }, "WORKS"),
      /*#__PURE__*/_createElementVNode("p", { class: "content-title_ja" }, "高校生VRアート作品集")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "content-grid" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "content-card" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "content-card_movie" }, [
          /*#__PURE__*/_createElementVNode("iframe", {
            width: "560",
            height: "315",
            src: "https://www.youtube.com/embed/xUlZOp4Q5cA",
            title: "YouTube video player",
            frameborder: "0",
            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowfullscreen: ""
          })
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "content-card_title" }, [
          /*#__PURE__*/_createElementVNode("p", { class: "content-card_title_box" }, "チーム"),
          /*#__PURE__*/_createElementVNode("p", { class: "content-card_title_text" }, "さねっちとゆかいななかまたち")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "content-card_title" }, [
          /*#__PURE__*/_createElementVNode("p", { class: "content-card_title_box" }, "作品名"),
          /*#__PURE__*/_createElementVNode("p", { class: "content-card_title_text" }, "『長崎 戦後の夜明け   広島 戦後の朝』")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "content-card_detail" }, " 広島と長崎の復興へ向かう様子を両地の文化や有名な観光地を用いて表現しました。広島と長崎の学生で制作パートを分け、一つの作品として完成させています。 ")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "content-card" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "content-card_movie" }, [
          /*#__PURE__*/_createElementVNode("iframe", {
            width: "560",
            height: "315",
            src: "https://www.youtube.com/embed/rmWtUy1Rd0Q",
            title: "YouTube video player",
            frameborder: "0",
            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowfullscreen: ""
          })
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "content-card_title" }, [
          /*#__PURE__*/_createElementVNode("p", { class: "content-card_title_box" }, "チーム"),
          /*#__PURE__*/_createElementVNode("p", { class: "content-card_title_text" }, "平和の預言者")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "content-card_title" }, [
          /*#__PURE__*/_createElementVNode("p", { class: "content-card_title_box" }, "作品名"),
          /*#__PURE__*/_createElementVNode("p", { class: "content-card_title_text" }, "『レジリエンス〜広島と長崎の生命力〜』")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "content-card_detail" }, " 「回復力・しなやかさ」という意味のレジリエンスをコンセプトに絶望の淵からの復興の様子を描いています。うまく役割分担をして完成させています。 ")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "content-card" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "content-card_movie" }, [
          /*#__PURE__*/_createElementVNode("iframe", {
            width: "560",
            height: "315",
            src: "https://www.youtube.com/embed/D_kll2JvAEY",
            title: "YouTube video player",
            frameborder: "0",
            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowfullscreen: ""
          })
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "content-card_title" }, [
          /*#__PURE__*/_createElementVNode("p", { class: "content-card_title_box" }, "チーム"),
          /*#__PURE__*/_createElementVNode("p", { class: "content-card_title_text" }, "くすのき")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "content-card_title" }, [
          /*#__PURE__*/_createElementVNode("p", { class: "content-card_title_box" }, "作品名"),
          /*#__PURE__*/_createElementVNode("p", { class: "content-card_title_text" }, "『復興被爆樹木 過去と未来』")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "content-card_detail" }, " 広島と長崎で、それぞれ未来と過去を表現しました。未来は守り育てていくもの・変わらないものと、過去は忘れてはならないものと捉え、うまく二つをトンネルで結び表現しました。 ")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "content-card" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "content-card_movie" }, [
          /*#__PURE__*/_createElementVNode("iframe", {
            width: "560",
            height: "315",
            src: "https://www.youtube.com/embed/uXP96ScCo30",
            title: "YouTube video player",
            frameborder: "0",
            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowfullscreen: ""
          })
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "content-card_title" }, [
          /*#__PURE__*/_createElementVNode("p", { class: "content-card_title_box" }, "チーム"),
          /*#__PURE__*/_createElementVNode("p", { class: "content-card_title_text" }, "ななぴぴのかいが")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "content-card_title" }, [
          /*#__PURE__*/_createElementVNode("p", { class: "content-card_title_box" }, "作品名"),
          /*#__PURE__*/_createElementVNode("p", { class: "content-card_title_text" }, "『光への道』")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "content-card_detail" }, " 広島と長崎、明るさ、昼と夜などの対照的な要素を用い、当時から復興までの様子を描きました。暗い過去から明るい未来が分かりやすく表現されています。 ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "content-title" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "content-title_en" }, "DRAWING SCENE"),
      /*#__PURE__*/_createElementVNode("p", { class: "content-title_ja" }, "制作風景")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "content-wide" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "content-wide_movie" }, [
        /*#__PURE__*/_createElementVNode("iframe", {
          width: "560",
          height: "315",
          src: "https://www.youtube.com/embed/bHVNTz5NL8I",
          title: "YouTube video player",
          frameborder: "0",
          allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
          allowfullscreen: ""
        })
      ]),
      /*#__PURE__*/_createElementVNode("p", null, [
        /*#__PURE__*/_createTextVNode(" 広島長崎をつないで、学生たちがディスカッションからテーマ決め、制作まで行いました。"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" VR空間を共有し、各班個性的な作品を仕上げました。"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" 特別ゲストとして出演いただいたせきぐちあいみ氏にもVRパフォーマンスを行っていただき、学生に向けてVR制作のノウハウを伝授・披露。"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" 学生の制作シーンでもせきぐちあいみ氏をはじめ、講師の2人や平和活動も行うMCのHIPPY氏からアドバイスをもらいながら、学生は作品を完成させました。"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" （※一部のみご紹介いたします。） ")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "special" }, [
    /*#__PURE__*/_createElementVNode("div", {
      id: "special",
      class: "special-title"
    }, [
      /*#__PURE__*/_createElementVNode("p", { class: "special-title_en" }, [
        /*#__PURE__*/_createTextVNode("SPECIAL"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode("CONTENTS")
      ]),
      /*#__PURE__*/_createElementVNode("p", { class: "special-title_ja" }, "せきぐちあいみ作品")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "special-wrap" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "special-detail" }, [
        /*#__PURE__*/_createTextVNode(" 本イベントにはVRアーティストのせきぐちあいみ氏が参加し"),
        /*#__PURE__*/_createElementVNode("br", { class: "sp-none" }),
        /*#__PURE__*/_createTextVNode("平和をモチーフにしたVRアート作品の解説、"),
        /*#__PURE__*/_createElementVNode("br", { class: "sp-none" }),
        /*#__PURE__*/_createTextVNode("そしてイベント内での即興VRアートパフォーマンスを行っていただきました。 ")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "special-head" }, [
        /*#__PURE__*/_createElementVNode("p", { class: "special-head_en" }, "VR ART"),
        /*#__PURE__*/_createElementVNode("p", { class: "special-head_ja" }, "VRアート")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "special-movie" }, [
        /*#__PURE__*/_createElementVNode("iframe", {
          width: "560",
          height: "315",
          src: "https://www.youtube.com/embed/b5JZeLl-qXo",
          title: "YouTube video player",
          frameborder: "0",
          allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
          allowfullscreen: ""
        })
      ]),
      /*#__PURE__*/_createElementVNode("p", { class: "special-text" }, [
        /*#__PURE__*/_createTextVNode(" 『平和への祈り』"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" せきぐちあいみ氏が、平和への祈りをVRアートで表現します。"),
        /*#__PURE__*/_createElementVNode("br", { class: "sp-none" }),
        /*#__PURE__*/_createTextVNode("広島は折り鶴や草木を使いポジティブな世界を描いていただきました。"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" 長崎をイメージした世界には平和の泉や平和記念像が美しく描かれ、"),
        /*#__PURE__*/_createElementVNode("br", { class: "sp-none" }),
        /*#__PURE__*/_createTextVNode("「美しい水や緑がずっと続きますように」という祈りが込められています。"),
        /*#__PURE__*/_createElementVNode("br")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "special-head" }, [
        /*#__PURE__*/_createElementVNode("p", { class: "special-head_en" }, "VR ART PERFORMANCE"),
        /*#__PURE__*/_createElementVNode("p", { class: "special-head_ja" }, "即興VRアートパフォーマンス")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "special-movie" }, [
        /*#__PURE__*/_createElementVNode("iframe", {
          width: "560",
          height: "315",
          src: "https://www.youtube.com/embed/onxD_6F7rGY",
          title: "YouTube video player",
          frameborder: "0",
          allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
          allowfullscreen: ""
        })
      ]),
      /*#__PURE__*/_createElementVNode("p", { class: "special-text" }, [
        /*#__PURE__*/_createTextVNode(" 『即興VRアート』"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" 第1部の遠隔平和学習を受けて、即興で平和への想いをVRアートで披露いただきました。"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" 授業中印象に残ったパートメインで描かれている平和の象徴・鳩に想いをのせ、"),
        /*#__PURE__*/_createElementVNode("br", { class: "sp-none" }),
        /*#__PURE__*/_createTextVNode("アートで表現しています。"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" ゼロから完成までの貴重なメイキングも見ることができます。ぜひ、ご覧ください。 ")
      ])
    ])
  ])
], -1))
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", null, _hoisted_2))
}